// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { gridThreeByThree16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-grid-three-by-three': IconGridThreeByThree;
    }
}

/**
 * The icon component for the 'gridThreeByThree' icon
 */
export class IconGridThreeByThree extends IconSvg {
    public constructor() {
        super(gridThreeByThree16X16);
    }
}

registerIconSvg('icon-grid-three-by-three', IconGridThreeByThree);
export const iconGridThreeByThreeTag = 'nimble-icon-grid-three-by-three';
